module.exports = __webpack_public_path__ + "static/img/max_pictgrid12_1080x868.023fe7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/max_pictgrid12_1080x868.jpg
// module id = FwpY
// module chunks = 0